import { render, staticRenderFns } from "./versionChecker.vue?vue&type=template&id=b2ca4566&scoped=true"
import script from "./versionChecker.vue?vue&type=script&lang=js"
export * from "./versionChecker.vue?vue&type=script&lang=js"
import style0 from "./versionChecker.vue?vue&type=style&index=0&id=b2ca4566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ca4566",
  null
  
)

export default component.exports